import { FileText, Download } from "lucide-react";
import { SectionTitle, EmptyState } from "@/components/platform/PortalLayout";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fmt = (d) => { try { return new Date(d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); } catch { return d; } };

export default function MyDocuments({ docs = [] }) {
  return (
    <div data-testid="my-documents">
      <SectionTitle>My Documents</SectionTitle>
      {docs.length === 0 ? <EmptyState testid="documents-empty">Signed waivers, agreements and reports uploaded by your coach will appear here.</EmptyState> : (
        <div className="space-y-2" data-testid="documents-list">
          {docs.map((d) => (
            <a key={d.id} data-testid={`document-${d.id}`} href={`${BACKEND}/api/documents/${d.id}/file`} target="_blank" rel="noreferrer"
              className="bg-[#121212] border border-white/10 p-4 flex items-center justify-between hover:border-white/25 transition-colors">
              <span className="flex items-center gap-3 min-w-0"><FileText size={18} className="text-white/50 shrink-0" /><span className="min-w-0"><span className="font-bold block truncate">{d.name}</span>{d.category && <span className="text-white/40 text-xs">{d.category} · {fmt(d.created_at)}</span>}</span></span>
              <span className="flex items-center gap-1 text-xs uppercase tracking-widest text-white/50 shrink-0"><Download size={14} /> Download</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
